/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'landscape': {
    width: 30,
    height: 20,
    viewBox: '0 0 30 20',
    data: '<path pid="0" d="M3 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3Zm0-2h24a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Z" fill-rule="nonzero" _fill="#D3DDE6"/>'
  }
})
